module.exports = __webpack_public_path__ + "static/media/contact-slide-3.ab6ace93.jpg";